import api from '@/helpers/api.js';

export default {
  async getTheme(slug) {
    const data = await api.get(`/Theme/Colors/${slug}`);
    return data;
  },

  async getCss(slug) {
    const data = await api.get(`/Theme/css/${slug}`);
    return data;
  }
};
